import "core-js/modules/esnext.global-this.js";
import t from "react";
var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function n(t) {
  var e = {
    exports: {}
  };
  return t(e, e.exports), e.exports;
}

var r = function r(t) {
  return t && t.Math == Math && t;
},
    o = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || function () {
  return this;
}() || Function("return this")(),
    i = function i(t) {
  try {
    return !!t();
  } catch (t) {
    return !0;
  }
},
    c = !i(function () {
  return 7 != Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1];
}),
    u = {}.propertyIsEnumerable,
    f = Object.getOwnPropertyDescriptor,
    a = {
  f: f && !u.call({
    1: 2
  }, 1) ? function (t) {
    var e = f(this, t);
    return !!e && e.enumerable;
  } : u
},
    l = function l(t, e) {
  return {
    enumerable: !(1 & t),
    configurable: !(2 & t),
    writable: !(4 & t),
    value: e
  };
},
    s = {}.toString,
    p = "".split,
    y = i(function () {
  return !Object("z").propertyIsEnumerable(0);
}) ? function (t) {
  return "String" == function (t) {
    return s.call(t).slice(8, -1);
  }(t) ? p.call(t, "") : Object(t);
} : Object,
    g = function g(t) {
  if (null == t) throw TypeError("Can't call method on " + t);
  return t;
},
    h = function h(t) {
  return y(g(t));
},
    b = function b(t) {
  return "object" == typeof t ? null !== t : "function" == typeof t;
},
    m = function m(t, e) {
  if (!b(t)) return t;
  var n, r;
  if (e && "function" == typeof (n = t.toString) && !b(r = n.call(t))) return r;
  if ("function" == typeof (n = t.valueOf) && !b(r = n.call(t))) return r;
  if (!e && "function" == typeof (n = t.toString) && !b(r = n.call(t))) return r;
  throw TypeError("Can't convert object to primitive value");
},
    d = {}.hasOwnProperty,
    v = function v(t, e) {
  return d.call(t, e);
},
    O = o.document,
    j = b(O) && b(O.createElement),
    w = !c && !i(function () {
  return 7 != Object.defineProperty(j ? O.createElement("div") : {}, "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    S = Object.getOwnPropertyDescriptor,
    E = {
  f: c ? S : function (t, e) {
    if (t = h(t), e = m(e, !0), w) try {
      return S(t, e);
    } catch (t) {}
    if (v(t, e)) return l(!a.f.call(t, e), t[e]);
  }
},
    T = function T(t) {
  if (!b(t)) throw TypeError(String(t) + " is not an object");
  return t;
},
    P = Object.defineProperty,
    x = {
  f: c ? P : function (t, e, n) {
    if (T(t), e = m(e, !0), T(n), w) try {
      return P(t, e, n);
    } catch (t) {}
    if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
    return "value" in n && (t[e] = n.value), t;
  }
},
    M = c ? function (t, e, n) {
  return x.f(t, e, l(1, n));
} : function (t, e, n) {
  return t[e] = n, t;
},
    _ = function _(t, e) {
  try {
    M(o, t, e);
  } catch (n) {
    o[t] = e;
  }

  return e;
},
    k = o["__core-js_shared__"] || _("__core-js_shared__", {}),
    C = Function.toString;

"function" != typeof k.inspectSource && (k.inspectSource = function (t) {
  return C.call(t);
});
var F,
    N,
    I,
    L = k.inspectSource,
    D = o.WeakMap,
    z = "function" == typeof D && /native code/.test(L(D)),
    A = n(function (t) {
  (t.exports = function (t, e) {
    return k[t] || (k[t] = void 0 !== e ? e : {});
  })("versions", []).push({
    version: "3.9.0",
    mode: "global",
    copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
  });
}),
    q = 0,
    G = Math.random(),
    R = A("keys"),
    W = {};

if (z) {
  var $ = k.state || (k.state = new (0, o.WeakMap)()),
      K = $.get,
      V = $.has,
      X = $.set;
  F = function F(t, e) {
    return e.facade = t, X.call($, t, e), e;
  }, N = function N(t) {
    return K.call($, t) || {};
  }, I = function I(t) {
    return V.call($, t);
  };
} else {
  var Y = R.state || (R.state = "Symbol(" + String("state") + ")_" + (++q + G).toString(36));
  W[Y] = !0, F = function F(t, e) {
    return e.facade = t, M(t, Y, e), e;
  }, N = function N(t) {
    return v(t, Y) ? t[Y] : {};
  }, I = function I(t) {
    return v(t, Y);
  };
}

var B = {
  set: F,
  get: N,
  has: I,
  enforce: function enforce(t) {
    return I(t) ? N(t) : F(t, {});
  },
  getterFor: function getterFor(t) {
    return function (e) {
      var n;
      if (!b(e) || (n = N(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
      return n;
    };
  }
},
    H = n(function (t) {
  var e = B.get,
      n = B.enforce,
      r = String(String).split("String");
  (t.exports = function (t, e, i, c) {
    var u,
        f = !!c && !!c.unsafe,
        a = !!c && !!c.enumerable,
        l = !!c && !!c.noTargetGet;
    "function" == typeof i && ("string" != typeof e || v(i, "name") || M(i, "name", e), (u = n(i)).source || (u.source = r.join("string" == typeof e ? e : ""))), t !== o ? (f ? !l && t[e] && (a = !0) : delete t[e], a ? t[e] = i : M(t, e, i)) : a ? t[e] = i : _(e, i);
  })(Function.prototype, "toString", function () {
    return "function" == typeof this && e(this).source || L(this);
  });
}),
    J = o,
    Q = function Q(t) {
  return "function" == typeof t ? t : void 0;
},
    U = Math.ceil,
    Z = Math.floor,
    tt = function tt(t) {
  return isNaN(t = +t) ? 0 : (t > 0 ? Z : U)(t);
},
    et = Math.min,
    nt = Math.max,
    rt = Math.min,
    ot = function ot(t) {
  return function (e, n, r) {
    var o,
        i,
        c = h(e),
        u = (o = c.length) > 0 ? et(tt(o), 9007199254740991) : 0,
        f = function (t, e) {
      var n = tt(t);
      return n < 0 ? nt(n + e, 0) : rt(n, e);
    }(r, u);

    if (t && n != n) {
      for (; u > f;) {
        if ((i = c[f++]) != i) return !0;
      }
    } else for (; u > f; f++) {
      if ((t || f in c) && c[f] === n) return t || f || 0;
    }

    return !t && -1;
  };
},
    it = (ot(!0), ot(!1)),
    ct = function ct(t, e) {
  var n,
      r = h(t),
      o = 0,
      i = [];

  for (n in r) {
    !v(W, n) && v(r, n) && i.push(n);
  }

  for (; e.length > o;) {
    v(r, n = e[o++]) && (~it(i, n) || i.push(n));
  }

  return i;
},
    ut = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    ft = ut.concat("length", "prototype"),
    at = {
  f: Object.getOwnPropertyNames || function (t) {
    return ct(t, ft);
  }
},
    lt = {
  f: Object.getOwnPropertySymbols
},
    st = function (t, e) {
  return arguments.length < 2 ? Q(J[t]) || Q(o[t]) : J[t] && J[t][e] || o[t] && o[t][e];
}("Reflect", "ownKeys") || function (t) {
  var e = at.f(T(t)),
      n = lt.f;
  return n ? e.concat(n(t)) : e;
},
    pt = function pt(t, e) {
  for (var n = st(e), r = x.f, o = E.f, i = 0; i < n.length; i++) {
    var c = n[i];
    v(t, c) || r(t, c, o(e, c));
  }
},
    yt = /#|\.prototype\./,
    gt = function gt(t, e) {
  var n = bt[ht(t)];
  return n == dt || n != mt && ("function" == typeof e ? i(e) : !!e);
},
    ht = gt.normalize = function (t) {
  return String(t).replace(yt, ".").toLowerCase();
},
    bt = gt.data = {},
    mt = gt.NATIVE = "N",
    dt = gt.POLYFILL = "P",
    vt = gt,
    Ot = E.f,
    jt = Object.keys || function (t) {
  return ct(t, ut);
},
    wt = function wt(t) {
  return Object(g(t));
},
    St = Object.assign,
    Et = Object.defineProperty,
    Tt = !St || i(function () {
  if (c && 1 !== St({
    b: 1
  }, St(Et({}, "a", {
    enumerable: !0,
    get: function get() {
      Et(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), {
    b: 2
  })).b) return !0;
  var t = {},
      e = {},
      n = Symbol(),
      r = "abcdefghijklmnopqrst";
  return t[n] = 7, r.split("").forEach(function (t) {
    e[t] = t;
  }), 7 != St({}, t)[n] || jt(St({}, e)).join("") != r;
}) ? function (t, e) {
  for (var n = wt(t), r = arguments.length, o = 1, i = lt.f, u = a.f; r > o;) {
    for (var f, l = y(arguments[o++]), s = i ? jt(l).concat(i(l)) : jt(l), p = s.length, g = 0; p > g;) {
      f = s[g++], c && !u.call(l, f) || (n[f] = l[f]);
    }
  }

  return n;
} : St;

function Pt() {
  return (Pt = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

!function (t, e) {
  var n,
      r,
      i,
      c,
      u,
      f = t.target,
      a = t.global,
      l = t.stat;
  if (n = a ? o : l ? o[f] || _(f, {}) : (o[f] || {}).prototype) for (r in e) {
    if (c = e[r], i = t.noTargetGet ? (u = Ot(n, r)) && u.value : n[r], !vt(a ? r : f + (l ? "." : "#") + r, t.forced) && void 0 !== i) {
      if (typeof c == typeof i) continue;
      pt(c, i);
    }

    (t.sham || i && i.sham) && M(c, "sham", !0), H(n, r, c, t);
  }
}({
  target: "Object",
  stat: !0,
  forced: Object.assign !== Tt
}, {
  assign: Tt
});

var xt = t.createContext({}),
    Mt = function Mt(e) {
  return function (n) {
    var r = _t(n.components);

    return t.createElement(e, Pt({}, n, {
      components: r
    }));
  };
},
    _t = function _t(e) {
  var n = t.useContext(xt);
  return "function" == typeof e ? e(n) : Object.assign({}, n, e);
},
    kt = function kt(_ref) {
  var e = _ref.components,
      n = _ref.children,
      r = _ref.disableParentContext;

  var o = _t(e);

  return r && (o = e), t.createElement(xt.Provider, {
    value: o
  }, n);
},
    Ct = {
  inlineCode: "code",
  wrapper: function wrapper(_ref2) {
    var e = _ref2.children;
    return t.createElement(t.Fragment, {}, e);
  }
},
    Ft = t.forwardRef(function (e, n) {
  var r = e.components,
      o = e.mdxType,
      i = e.originalType,
      c = e.parentName,
      u = function (t, e) {
    if (null == t) return {};
    var n,
        r,
        o = {},
        i = Object.keys(t);

    for (r = 0; r < i.length; r++) {
      e.indexOf(n = i[r]) >= 0 || (o[n] = t[n]);
    }

    return o;
  }(e, ["components", "mdxType", "originalType", "parentName"]),
      f = _t(r);

  return t.createElement(f["".concat(c, ".").concat(o)] || f[o] || Ct[o] || i, r ? Object.assign({
    ref: n
  }, u, {
    components: r
  }) : Object.assign({
    ref: n
  }, u));
});

function Nt(e, n) {
  var r = arguments,
      o = n && n.mdxType;

  if ("string" == typeof e || o) {
    var _i = r.length,
        _c = new Array(_i);

    _c[0] = Ft;
    var _u = {};

    for (var _t2 in n) {
      hasOwnProperty.call(n, _t2) && (_u[_t2] = n[_t2]);
    }

    _u.originalType = e, _u.mdxType = "string" == typeof e ? e : o, _c[1] = _u;

    for (var _t3 = 2; _t3 < _i; _t3++) {
      _c[_t3] = r[_t3];
    }

    return t.createElement.apply(null, _c);
  }

  return t.createElement.apply(null, r);
}

Ft.displayName = "MDXCreateElement", Nt.Fragment = t.Fragment;
export { xt as MDXContext, kt as MDXProvider, Nt as mdx, _t as useMDXComponents, Mt as withMDXComponents };